import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.77.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SeoKeywordProvider"] */ "/app/web/components/product-series/SeoKeywordProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimationSection"] */ "/app/web/components/service/AnimationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicationsSection"] */ "/app/web/components/service/ApplicationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandServicesSection"] */ "/app/web/components/service/BrandServicesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactFormSection"] */ "/app/web/components/service/ContactFormSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceValueSection"] */ "/app/web/components/service/ServiceValueSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleCtaSection"] */ "/app/web/components/service/SimpleCtaSection.tsx");
